/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Trial_TitleInputs */

const en_image_export_trial_title = /** @type {(inputs: Image_Export_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trial Mode`)
};

const fr_image_export_trial_title = /** @type {(inputs: Image_Export_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mode d'essai`)
};

const de_image_export_trial_title = /** @type {(inputs: Image_Export_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testmodus`)
};

const it_image_export_trial_title = /** @type {(inputs: Image_Export_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modalità di prova`)
};

const ru_image_export_trial_title = /** @type {(inputs: Image_Export_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пробный режим`)
};

const es_image_export_trial_title = /** @type {(inputs: Image_Export_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modo de prueba`)
};

const zh_cn2_image_export_trial_title = /** @type {(inputs: Image_Export_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`试用模式`)
};

const ja_image_export_trial_title = /** @type {(inputs: Image_Export_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トライアルモード`)
};

const hi_image_export_trial_title = /** @type {(inputs: Image_Export_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परीक्षण मोड़`)
};

const pt_pt2_image_export_trial_title = /** @type {(inputs: Image_Export_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modo de teste`)
};

/**
* | output |
* | --- |
* | "Trial Mode" |
*
* @param {Image_Export_Trial_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_trial_title = /** @type {((inputs?: Image_Export_Trial_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Trial_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_trial_title(inputs)
	if (locale === "de") return de_image_export_trial_title(inputs)
	if (locale === "it") return it_image_export_trial_title(inputs)
	if (locale === "ru") return ru_image_export_trial_title(inputs)
	if (locale === "es") return es_image_export_trial_title(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_trial_title(inputs)
	if (locale === "ja") return ja_image_export_trial_title(inputs)
	if (locale === "hi") return hi_image_export_trial_title(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_trial_title(inputs)
	return en_image_export_trial_title(inputs)
});